import basePdfstyles from "@/modules/Clinical/components/ReportPDF/styles"
import ulab_hrz_logo from "@/assets/images/clinical/report/pdf/logo.png"

export const pdfstyles = {
  ...basePdfstyles,
  page: {
    ...basePdfstyles.page,
    // size: "LETTER",
    padding: "33px",
    flexDirection: "column",
    alignItems: "flex-start",
  },
  footerTextBase: {
    position: "absolute",
    textAlign: "center",
    color: "rgba(0, 0, 0, 0.38)",
    fontFamily: "Helvetica",
    fontSize: 10,
    fontStyle: "normal",
    fontWeight: 500,
    lineHeight: "160%",
    paddingBottom: 24,
  },
  header: {
    ...basePdfstyles.header,
    padding: "0 16px",
  },
  content: {
    ...basePdfstyles.content,
    padding: "0 16px",
  },
  logocontainer: {
    ...basePdfstyles.logocontainer,
    alignItems: "center",
    justifyContent: "center",
  },
  cols: {
    ...basePdfstyles.cols,
    padding: "0 16px",
  },
} as const

export const labelStyle = {
  ...pdfstyles.text,
  fontSize: 12,
  fontWeight: 400,
  letterSpacing: 0.4,
} as const

export const valueStyle = {
  ...pdfstyles.text,
  fontSize: 12,
  fontWeight: 700,
  letterSpacing: 0.4,
} as const

export const rowStyle = {
  display: "flex" as const,
  flexDirection: "row" as const,
  alignItems: "center" as const,
  gap: 8,
}

export const imageStyle = {
  maxWidth: "100%",
  width: 564,
  maxHeight: 600,
  objectFit: "contain" as const,
  alignSelf: "center" as const,
}

export const footerStyle = {
  ...pdfstyles.footerTextBase,
  bottom: 24,
  left: 0,
  right: 0,
}

export { ulab_hrz_logo }

export default pdfstyles
